// src/components/PresskitTemplate.tsx

import Header from "./Header";
import Footer from "./Footer";

interface PresskitProps {
  title: string;
  developer: string;
  publisher: string;
  platform: string;
  socialMedia: string;
  website: string;
  description: string;
  history: string;
  features: string[];
  steamLink: string;
  trailerUrls: string[];
  screenshotUrls: string[];
  logos: string[];
  banners: string[];
  mascots: string[];
  aboutDeveloper: string;
  aboutPublisher: string;
  credits: string;
}

const PresskitTemplate = ({
  title,
  developer,
  publisher,
  platform,
  socialMedia,
  website,
  description,
  history,
  features,
  steamLink,
  trailerUrls,
  screenshotUrls,
  logos,
  banners,
  mascots,
  aboutDeveloper,
  aboutPublisher,
  credits,
}: PresskitProps) => {
  const isSteamWidget = steamLink.includes("store.steampowered.com/widget");

  const sectionHeaderStyle = { fontSize: "2rem", marginTop: "2rem" };
  const subHeaderStyle = { fontSize: "1.35rem", marginTop: "1.5rem" };

  return (
    <>
      <Header />
      <div style={{ backgroundColor: "white", color: "black", padding: "2rem 10%", display: "flex", justifyContent: "center", fontSize: "1.1rem", lineHeight: "1.6", whiteSpace: "pre-wrap"}}>
        <div style={{ maxWidth: "800px", width: "100%" }}>
          <h1 style={{ fontSize: "2.5rem" }}>{title} Presskit</h1>

          {/* Section 1: Factsheet */}
          <section>
            <h2 style={sectionHeaderStyle}>Factsheet</h2>
            <p><strong>Developer:</strong> {developer}</p>
            <p><strong>Publisher:</strong> {publisher}</p>
            <p><strong>Platform:</strong> {platform}</p>
            <p><strong>Social Media:</strong> <a href={socialMedia} target="_blank" rel="noreferrer">{socialMedia}</a></p>
            <p><strong>Website:</strong> <a href={website} target="_blank" rel="noreferrer">{website}</a></p>
          </section>

          {/* Section 2: Pitch */}
          <section>
            <h2 style={sectionHeaderStyle}>Pitch</h2>
            <p><strong>Description:</strong> {description}</p>
            <p><strong>History:</strong> {history}</p>
            <strong>Features:</strong>
            <ul>
              {features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
            {isSteamWidget ? (
              <div style={{ marginTop: "1rem" }}>
                <h3 style={subHeaderStyle}>Steam Page</h3>
                <iframe
                  src={steamLink}
                  frameBorder="0"
                  width="100%"
                  height="190"
                  title="Steam Widget"
                  style={{ borderRadius: "8px" }}
                ></iframe>
              </div>
            ) : (
              <p><strong>Steam Link:</strong> <a href={steamLink} target="_blank" rel="noreferrer">{steamLink}</a></p>
            )}
          </section>

          {/* Section 3: Media */}
          <section>
            <h2 style={sectionHeaderStyle}>Media</h2>
            <h3 style={subHeaderStyle}>Trailers</h3>
            {trailerUrls.map((url, i) => (
              <div key={i} className="video-responsive" style={{ maxWidth: "640px", margin: "0 auto" }}>
                <iframe
                  width="100%"
                  height="315"
                  src={url}
                  title={`Trailer ${i + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ))}
            <h3 style={subHeaderStyle}>Screenshots</h3>
            <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
              {screenshotUrls.map((img, i) => (
                <img key={i} src={img} alt={`screenshot-${i}`} className="img-responsive" style={{ maxWidth: "300px" }} />
              ))}
            </div>
          </section>

          {/* Section 4: Branding */}
          <section>
            <h2 style={sectionHeaderStyle}>Branding</h2>
            <h3 style={subHeaderStyle}>Logos</h3>
            {logos.map((logo, i) => (
              <img key={i} src={logo} alt={`logo-${i}`} className="img-responsive" style={{ maxWidth: "300px" }} />
            ))}
            <h3 style={subHeaderStyle}>Banners</h3>
            {banners.map((banner, i) => (
              <img key={i} src={banner} alt={`banner-${i}`} className="img-responsive" style={{ maxWidth: "100%" }} />
            ))}
            <h3 style={subHeaderStyle}>Mascots</h3>
            {mascots.map((mascot, i) => (
              <img key={i} src={mascot} alt={`mascot-${i}`} className="img-responsive" style={{ maxWidth: "300px" }} />
            ))}
          </section>

          {/* Section 5: About */}
          <section>
            <h2 style={sectionHeaderStyle}>About</h2>
            <p><strong>About Developer:</strong><pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>{aboutDeveloper}</pre></p>
            <p><strong>About Publisher:</strong><pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>{aboutPublisher}</pre></p>
            <div>
              <strong>Credits:</strong>
              <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>{credits}</pre>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PresskitTemplate;
